var render = function render(){var _vm=this,_c=_vm._self._c;return _c('com-page',[_c('com-search',{attrs:{"columns":_vm.searchColumn},on:{"search":_vm.handleSearch}},[[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleCreated}},[_vm._v("添加套餐卡")])]],2),_c('com-card',[_c('PackageCard',{ref:"PackageCardRef"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }